import type { WorldMeta } from "../registry";

export const meta: WorldMeta = {
  id: "FW-26",
  name: "Planum",
  slug: "planum",
  title: "Planum — a Fable World: architecture studio page",
  description:
    "An original architecture landing page designed by Fable: horizontal rooms, an exploding massing model in three.js, concrete and graphite."
};

export default meta;
